import { supabase } from './supabase';

export const profileService = {
  // Get user profile
  async getProfile(userId: string) {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .maybeSingle();

    return { data, error };
  },

  // Upsert user profile (creates if not exists, updates if exists)
  async updateProfile(userId: string, email: string, phone: string | null) {
    const { data, error } = await supabase
      .from('profiles')
      .upsert(
        {
          id: userId,
          email: email,
          phone: phone,
          updated_at: new Date().toISOString(),
        },
        {
          onConflict: 'id',
        }
      )
      .select()
      .single();

    return { data, error };
  },

  // Update user language preference
  async updateLanguage(userId: string, language: string) {
    const { data, error } = await supabase
      .from('profiles')
      .upsert(
        {
          id: userId,
          language: language,
          updated_at: new Date().toISOString(),
        },
        {
          onConflict: 'id',
        }
      )
      .select()
      .single();

    return { data, error };
  },

  // Create user profile (called after sign up)
  async createProfile(userId: string, email: string) {
    const { data, error } = await supabase
      .from('profiles')
      .insert({
        id: userId,
        email: email,
        phone: null,
        language: null,
      })
      .select()
      .single();

    return { data, error };
  },
};

// Password update helper
export const updateUserPassword = async (newPassword: string) => {
  const { data, error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  return { data, error };
};
